import React from "react";
import ProgressBar from "../../../../form/ProgressBar";
import {ProductColumn} from "../../../../../utils/formatters";
import SelectorGrid from "../../../../form/SelectorGrid/SelectorGrid";
import ComponentLoader from "../../../../form/ComponentLoader";
import {get} from "../../../../../utils/dotutils";

const Bar = (props) => <ProgressBar
    min={0}
    max={get(props, "values.items.0.qty") || 0}
    now={((props.aggregationRows || [])[0] || {}).qty || 0}
    style={{minWidth: ((props.aggregationRows || [])[0] || {}).qty || 0 > 0 ? '140px' : 0}}
    label={`${((props.aggregationRows || [])[0] || {}).qty || 0} db / ${get(props, "values.items.0.qty") || 0} db`}
/>;

const Progressor = (props) => <ComponentLoader componentName="componentlist" component="StockItem" filter={[{field: "store", value: props.store}]} aggregations={{fields: {qty: {field: "qty", type: "SUM"}}}}>
    <Bar {...props} />
</ComponentLoader>;

export default class Progress extends React.Component {

    loadProgress = () => {
        this.items && this.items.refreshBackground();
    }

    render() {
        return (
            <SelectorGrid
                ref={(e) => this.items = e}
                exports={[{as: "excel", label: "Excel", icon: "far fa-file-excel", params: {name: ((this.props.values.label ? this.props.values.label + " - " : "") + "Eltérések")}}]}
                {...this.props.props.pool}
                parameters={{...this.props.props.pool.parameters}}
                aggregations={{
                    fields: {
                        "qty": {
                            field: "qty", type: "SUM"
                        }
                    }
                }}
                columns={{
                    "displayname": {
                        ...ProductColumn("component_id"),
                    },
                }}
                type={(props) => <Progressor {...props} store={this.props.source} />}
            />
        );
    }
}